"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdFormik = require("cccisd-formik");
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _styleAssignmentcard = _interopRequireDefault(require("../../../Card/style-assignmentcard.css"));
var _SurveySelector = _interopRequireDefault(require("../SurveySelector"));
var _helpers = require("../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function DraggableCard(_ref) {
  var draggableId = _ref.draggableId,
    index = _ref.index,
    title = _ref.title,
    actions = _ref.actions,
    children = _ref.children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
    draggableId: draggableId,
    index: index
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames2["default"])(_styleAssignmentcard["default"].cardWrapper, _defineProperty({}, _styleAssignmentcard["default"].expanded, isExpanded)),
      style: {
        marginTop: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].header
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].leftSide,
      onClick: function onClick() {
        return setIsExpanded(!isExpanded);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: [_styleAssignmentcard["default"].collapseArrow, isExpanded ? _styleAssignmentcard["default"].expanded : _styleAssignmentcard["default"].collapsed].join(' ')
    }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].titleArea
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].title
    }, title))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].rightSide
    }, actions)), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
      className: _styleAssignmentcard["default"].content
    }, children)));
  });
}
function FormTimepoint(_ref2) {
  var surveyList = _ref2.surveyList,
    timepointNumber = _ref2.timepointNumber,
    removeTimepoint = _ref2.removeTimepoint,
    timepoint = _ref2.timepoint;
  var index = timepointNumber - 1;
  var title = "Timepoint ".concat(timepointNumber, " ").concat(timepoint.label ? "- ".concat(timepoint.label) : '');
  var actions = /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-danger",
    type: "button",
    onClick: function onClick() {
      return removeTimepoint();
    }
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null));
  return /*#__PURE__*/_react["default"].createElement(DraggableCard, {
    draggableId: "timepoint_".concat(index),
    index: index,
    title: title,
    actions: actions
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "timepoints[".concat(index, "].label"),
    component: _cccisdFormik.CccisdInput,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Timepoint Label",
      tooltip: "The label for this timepoint."
    })
  })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "timepoints[".concat(index, "].surveys"),
    label: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Surveys",
      tooltip: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Select the default survey(s) for this timepoint."))
    })),
    component: _SurveySelector["default"],
    surveyList: surveyList
  }));
}
var _default = exports["default"] = FormTimepoint;